import PanelDivider from 'Components/PanelDivider';
import { actions as deviceActions } from 'ducks/devices';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeviceDetails from './DeviceDetails';
import WiseBoxDetails from './WiseBoxDetails';

const Component = props => {
    const { childDevices, device, installationZones } = props;
    const remove = deviceActions.useRemove();

    const submitting = useSelector(state => state.devices.submitting);

    const dispatch = useDispatch();
    useEffect(() => {
        if (device.new_wise_box) {
            dispatch(deviceActions.fetchOne(device.id));
        }
    }, [device.id, device.new_wise_box, dispatch]);

    return (
        <>
            <DeviceDetails childDevices={childDevices} device={device} installationZones={installationZones} remove={remove} submitting={submitting}/>
            <PanelDivider/>
            <WiseBoxDetails device={device} submitting={submitting}/>
            <PanelDivider/>
        </>
    );
};

export default Component;
